import { useAccountData } from './useAccountData';

/** Whether the current seller has at least one active API sales channel. */
export const useHasApiIntegration = (): boolean => {
    const { data } = useAccountData();

    return data?.salesChannels?.some((salesChannel) => salesChannel.ecommerceSettings?.ecommerceName === 'API') ?? false;
};
